import { render, staticRenderFns } from "./Paganation.vue?vue&type=template&id=61de824c&scoped=true&"
import script from "./Paganation.vue?vue&type=script&lang=js&"
export * from "./Paganation.vue?vue&type=script&lang=js&"
import style0 from "./Paganation.vue?vue&type=style&index=0&id=61de824c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de824c",
  null
  
)

export default component.exports